import { Link } from "../lib/router-compat";
import { PanImage, YouTubeEmbed } from "./PageShell";

const ENSEMBLES = [
  { name: "Rhythm Rockets", year: "Founded in 1992 by Nigel Chase", body: "", video: { id: "0CoKmpLT6dM", title: "Planet Pan: Bees Melody (2016)" } },
  { name: "Planet Pan Steel Band", year: "Founded in 1993 by Nigel and Carl Chase", body: "", video: { id: "PZipIzeKHMo", title: "Pan Coalition in Blue Hill, Maine — 7/8/2013" } },
  { name: "Flash in the Pans", year: "Founded in 1990 by Carl Chase, Butch Czerwinski, and Nigel Chase", body: "Community Adult Steel Band", video: { id: "E1PhhkqQbb4", title: "Flash in the Pans steel drum band" } },
  { name: "Pan Coalition", year: "Founded in 1998 by Nigel and Carl Chase", body: "A coalition of players of all ages and experience. Pan Coalition perform around the country and internationally.", video: { id: "iDMmHjSMDsk", title: "Pan Coalition — Outta De Box" } },
];

export function ClassesContent() {
  return (
    <div className="space-y-12">
      <div className="grid gap-6 md:grid-cols-[minmax(0,1fr)_280px] border-y border-border/45 py-7">
        <div>
          <div className="text-[10px] uppercase tracking-[0.5em] text-primary">Now enrolling</div>
          <h2 className="mt-4 font-display italic text-3xl md:text-5xl leading-[0.98]">
            Brooksville Community Beginner Steel Band
          </h2>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground/70">
            Open class for new players. No experience required — just curiosity and a willingness to make sound with other people.
          </p>
        </div>
        <div className="border-l border-border/45 pl-6">
          <div className="font-display italic text-4xl leading-none">Oct. 14</div>
          <Link to="/calendar" className="mt-5 inline-flex items-center gap-3 text-[11px] tracking-[0.32em] uppercase text-primary hover:text-primary/70 transition group">
            <span className="h-px w-8 bg-primary group-hover:w-12 transition-all" />
            Schedule
          </Link>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 border-b border-border/45">
        {["Youth bands", "Adult classes", "Private lessons", "School residencies"].map((item) => (
          <div key={item} className="border-r border-border/35 last:border-r-0 px-4 py-4 first:pl-0 md:px-5 md:first:pl-0">
            <div className="text-[11px] uppercase tracking-[0.22em] text-foreground/60">{item}</div>
          </div>
        ))}
      </div>

      <div>
        <div className="flex items-end justify-between gap-6 mb-7 border-b border-border/40 pb-5">
          <div>
            <div className="text-[10px] uppercase tracking-[0.5em] text-primary/80">The roster</div>
            <h2 className="mt-3 font-display italic text-3xl md:text-4xl">Student bands</h2>
          </div>
        </div>
        <div className="divide-y divide-border/45">
          {ENSEMBLES.map((e) => (
            <article key={e.name} className="grid gap-5 md:grid-cols-[minmax(0,0.9fr)_minmax(300px,1.1fr)] md:items-center py-7">
              <div>
                <h3 className="font-display italic text-3xl leading-tight">{e.name}</h3>
                {e.body && <p className="text-[15px] text-foreground/70 leading-relaxed mt-4">{e.body}</p>}
                <div className="text-[11px] uppercase tracking-[0.28em] text-primary/80 mt-4">{e.year}</div>
              </div>
              <div className="md:max-w-[500px] md:justify-self-end w-full">
                <YouTubeEmbed id={e.video.id} title={e.video.title} />
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}

const GALLERY = [
  "1468945234.jpg", "acsb-wide 3.jpg", "1475694459.JPG", "acsb_outside_closeup 2.jpg",
  "parade3.jpg", "unnamed-1-b99c3da.jpg", "unnamed-46bac39.jpg", "acsb_monhegan_03-3 2.jpg",
  "nigel 2.jpg", "band.jpg",
];

export function ClarionContent() {
  return (
    <div className="space-y-16">
      <div className="relative overflow-hidden rounded-3xl border border-border/40">
        <div className="aspect-[16/10]">
          <PanImage id="blob-4a1fe6f.png" alt="Atlantic Clarion Steel Band" width={1800} />
        </div>
      </div>

      <div className="max-w-3xl space-y-6 text-[17px] leading-relaxed text-foreground/80">
        <p>Atlantic Clarion is a premier musical ensemble that specializes in providing world-class steel pan performances for a variety of events, including concerts, parties, weddings, and more. Our skilled and talented musicians are passionate about creating unforgettable experiences for our clients and their guests.</p>
        <p>As a small group of dedicated professionals, we take pride in delivering exceptional performances that leave a lasting impression. Our music is not only beautiful, but it also has the power to uplift and inspire audiences of all ages.</p>
        <p>Let Atlantic Clarion enhance your special event with our unique blend of Caribbean and world music. Contact us today to schedule your next performance.</p>
      </div>

      <div>
        <div className="flex items-end justify-between gap-6 mb-10 border-b border-border/40 pb-5">
          <div>
            <div className="text-[10px] uppercase tracking-[0.5em] text-primary/80">Players past and present</div>
            <h2 className="mt-3 font-display italic text-3xl md:text-4xl">Atlantic Clarion's players past and present</h2>
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
          {GALLERY.map((id) => (
            <div key={id} className="aspect-square overflow-hidden rounded-2xl border border-border/40">
              <PanImage id={id} alt="Atlantic Clarion" width={600} />
            </div>
          ))}
        </div>
      </div>

      <div className="rounded-3xl border border-border/40 bg-gradient-to-br from-card/60 to-card/20 p-8 md:p-12 text-center">
        <h2 className="font-display italic text-3xl md:text-5xl leading-[1.05] max-w-2xl mx-auto">Book now.</h2>
        <div className="mt-7">
          <a href="#contact" className="inline-flex items-center justify-center px-7 py-3 bg-primary text-primary-foreground text-[11px] tracking-[0.3em] uppercase rounded-full hover:opacity-90 transition shadow-lg shadow-primary/20">
            Book now
          </a>
        </div>
      </div>
    </div>
  );
}

const PANS_CATALOG = ["D Tenors", "C Tenors", "Double Tenors", "Double Seconds", "Guitars", "Cellos", "Tenor Bass", "Six Bass"];
const PEOPLE = [
  { role: "Owner, Maker and Tuner", name: "Nigel P. Chase" },
  { role: "Founder", name: "Carl Chase" },
  { role: "Master Tuner / Mentor", name: "Roland Harrigan" },
];

export function MainePanContent() {
  return (
    <div className="space-y-16">
      <div className="relative overflow-hidden rounded-3xl border border-primary/30 bg-gradient-to-br from-primary/15 via-card/40 to-transparent">
        <div className="relative grid md:grid-cols-2">
          <div className="aspect-[4/3] md:aspect-auto overflow-hidden">
            <PanImage id="unnamed-2.jpg" alt="Maine Pan Productions" width={1200} />
          </div>
          <div className="p-8 md:p-10 flex flex-col justify-center">
            <div className="text-[10px] uppercase tracking-[0.5em] text-primary">Everything for steelbands</div>
            <h2 className="mt-4 font-display italic text-3xl md:text-4xl leading-[1.05]">Contact Nigel for prices.</h2>
            <div className="mt-7 flex flex-wrap gap-3">
              <a href="mailto:nigelchase@gmail.com" className="inline-flex items-center justify-center px-6 py-2.5 bg-primary text-primary-foreground text-[11px] tracking-[0.3em] uppercase rounded-full hover:opacity-90 transition shadow-lg shadow-primary/20">Email Nigel</a>
              <a href="#contact" className="inline-flex items-center justify-center px-6 py-2.5 border border-border/60 text-[11px] tracking-[0.3em] uppercase rounded-full hover:border-primary/60 hover:text-primary transition">Send a message</a>
            </div>
          </div>
        </div>
      </div>

      <div>
        <div className="flex items-end justify-between gap-6 mb-10 border-b border-border/40 pb-5">
          <div>
            <div className="text-[10px] uppercase tracking-[0.5em] text-primary/80">The makers</div>
            <h2 className="mt-3 font-display italic text-3xl md:text-4xl">Steel pan makers and tuners</h2>
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-5">
          {PEOPLE.map((p) => (
            <div key={p.name} className="rounded-2xl border border-border/40 bg-card/30 p-7 hover:border-primary/40 transition-colors">
              <div className="text-[10px] uppercase tracking-[0.4em] text-primary mb-4">{p.role}</div>
              <div className="font-display italic text-2xl">{p.name}</div>
            </div>
          ))}
        </div>
      </div>

      <div>
        <div className="flex items-end justify-between gap-6 mb-10 border-b border-border/40 pb-5">
          <div>
            <div className="text-[10px] uppercase tracking-[0.5em] text-primary/80">The catalog</div>
            <h2 className="mt-3 font-display italic text-3xl md:text-4xl">Everything for steelbands</h2>
          </div>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3">
          {PANS_CATALOG.map((name) => (
            <div key={name} className="group rounded-2xl border border-border/40 bg-card/30 p-5 hover:border-primary/50 hover:bg-card/50 transition">
              <div className="font-display italic text-xl">{name}</div>
            </div>
          ))}
        </div>
        <ul className="mt-6 space-y-1 text-sm text-foreground/65">
          <li>Used pans available for rent and for sale</li>
          <li>Stands for all</li>
          <li>Sticks for all</li>
          <li>Contact Nigel for prices</li>
        </ul>
      </div>
    </div>
  );
}
